import { Amenity } from 'utils/entities';

interface MapAmenitiesParams {
  list: Amenity[];
  amenities: Record<Amenity, boolean>;
  t: (key: string, params?: any) => string;
  titleKey: string;
  secureRoomAmenities: Amenity[];
}

export const mapAmenitiesWithSecure = ({
  list,
  amenities,
  t,
  titleKey,
  secureRoomAmenities,
}: MapAmenitiesParams) => {
  const secureRoomList = new Set(secureRoomAmenities);

  const secureRoomActive = amenities.secureRoom ? Amenity.SecureRoom : false;
  const mamakActive = amenities.mamak ? Amenity.Mamak : false;
  const miklatActive = amenities.miklat ? Amenity.Miklat : false;

  const noSecure = !secureRoomActive && !mamakActive && !miklatActive;

  let securePlaceholderAdded = false;

  return list.reduce(
    (acc, amenity) => {
      if (noSecure && secureRoomList.has(amenity)) {
        if (!securePlaceholderAdded) {
          acc.inactive.push({
            locator: 'no-secure-room',
            isActive: false,
            title: t('unitPage.amenities.checklist.noSecureRoom'),
          });
          securePlaceholderAdded = true;
        }
        return acc;
      }

      const amenityItem = {
        locator: amenity,
        isActive: amenities[amenity],
        title: t(titleKey, { amenity }),
      };

      if (noSecure || !secureRoomList.has(amenity)) {
        if (amenityItem.isActive) acc.active.push(amenityItem);
        else acc.inactive.push(amenityItem);
      }
      else {
        const secureActiveList = new Set(
          [ secureRoomActive, mamakActive, miklatActive ].filter(Boolean)
        );

        if (secureActiveList.has(amenity)) {
          acc.active.push(amenityItem);
        }
      }

      return acc;
    },
    { active: [], inactive: [] }
  );
};
